import React from 'react';
import StepWizard from 'react-step-wizard';
import Step1 from './Step1';
import Step2 from './Step2';
import { RegisterProvider } from './RegisterContext';
import hansepayWhiteLogo from '../../assets/hansepay-white.png';

function Register() {
  return (
    <div className='min-h-screen bg-[#EBF4FB] text-[#0B1929]'>
      <header className='flex h-[60px] items-center justify-between bg-[linear-gradient(135deg,#060D1A_0%,#0F2540_55%,#163659_100%)] px-5 sm:px-10'>
        <a href='/' className='flex items-center gap-2.5 no-underline'>
          <img src={hansepayWhiteLogo} width={26} height={26} alt='HansePay' className='block shrink-0' />
          <span className='wordmark inline-block translate-y-px text-[18px] leading-none tracking-[-0.015em] text-white'>HansePay</span>
        </a>
      </header>

      <main className='flex justify-center px-4 pb-16 pt-[10vh] sm:px-6'>
        <div className='w-full max-w-[540px]'>
          <div className='overflow-hidden rounded-[20px] bg-white shadow-[0_4px_32px_rgba(11,25,41,0.08)]'>
            <RegisterProvider>
              <StepWizard>
                <Step1 />
                <Step2 />
              </StepWizard>
            </RegisterProvider>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Register;
